import { Component, inject } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BannerCardComponent } from '@shared/components/banner-card/banner-card.component';
import { IBreadcrumb } from '@shared/components/breadcrumb/breadcrumb.component';
import { ContentContainerComponent } from '@shared/components/content-container/content-container.component';
import { AdminInvitationsTabComponent } from './admin-invitations-tab/admin-invitations-tab.component';
import { AdminUserGroupStore } from './admin-user-group.store';
import { AdminUserGroupsTabComponent } from './admin-user-groups-tab/admin-user-groups-tab.component';
import { AdminUsersTabComponent } from './admin-users-tab/admin-users-tab.component';

@Component({
  imports: [
    ContentContainerComponent,
    MatTabsModule,
    TranslateModule,
    AdminUserGroupsTabComponent,
    AdminUsersTabComponent,
    AdminInvitationsTabComponent,
    BannerCardComponent,
  ],
  providers: [AdminUserGroupStore],
  selector: 'app-admin-user-group',
  styleUrl: './admin-user-group.component.scss',
  templateUrl: './admin-user-group.component.html',
})
export class AdminUserGroupComponent {
  public readonly store = inject(AdminUserGroupStore);
  private readonly translate = inject(TranslateService);

  public readonly breadcrumbs: IBreadcrumb[] = [
    {
      label: this.translate.instant('pages.admin.userGroup.navigationTitle'),
      link: '/dashboard',
    },
  ];

  constructor() {
    this.store.fetchUserGroups();
  }
}
